import React, { useMemo } from "react";
import { availableReportsType } from "../shared/utils/cropr";
import ReportInnerNav from "./ReportInnerNav";
import ReportInnerSubNav, { ReportInnerNavProps } from "./ReportInnerSubNav";

const ReportNavigation = ({ availableReports }: { availableReports: availableReportsType }) => {
  const innerNavItems: ReportInnerNavProps[] = useMemo(() => {
    return Object.entries(availableReports).map(([groupKey, group]) => {
      return {
        title: group.groupName,
        links: Object.entries(group.reports).map(([reportKey, report]) => {
          return { title: report.title, to: `#reports/${groupKey}/${reportKey}/` };
        }),
      };
    });
  }, [availableReports]);

  return (
    <ReportInnerNav>
      {innerNavItems?.map((subnav) => (
        <ReportInnerSubNav key={subnav.title} title={subnav.title} links={subnav.links} />
      ))}
    </ReportInnerNav>
  );
};

export default ReportNavigation;
